/**
 * Formats county names with appropriate suffix (County or Parish)
 * @param county - The county name
 * @param state - The state abbreviation
 * @returns The formatted county name with suffix
 */
export const formatCountyName = (county: string | undefined, state: string): string => {
  if (!county) return '';

  // Don't add suffix if it already exists
  if (county.toLowerCase().includes('county') || county.toLowerCase().includes('parish')) {
    return county;
  }

  // Louisiana uses "Parish" instead of "County"
  const suffix = state === 'LA' ? 'Parish' : 'County';

  return `${county} ${suffix}`;
};
